import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { onBeforeMount, ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import TicketViewComment from '@/modules/ticket/components/TicketViewComment.vue';
import TicketViewCommentForm from '@/modules/ticket/components/TicketViewCommentForm.vue';
import { Ticket } from '@/modules/ticket/Ticket';
import { TicketComment, useTicketComment } from '@/modules/ticket/TicketComment';

interface TicketViewCommentsProps {
	ticket: Ticket;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketViewComments',
  props: {
    ticket: {}
  },
  setup(__props: any) {

const { $gettext } = useGettext();
const props = __props;
const resource = useTicketComment(props.ticket.id);
const comments = ref<TicketComment[]>([]);

onBeforeMount(async () => {
	comments.value = await resource.getAllNoPagination();
})

const commentSaved = (newComment) => {
	Flash.success($gettext('Din kommentar sparades!'));
	comments.value.push(newComment);
};

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("h3", null, [
      _createTextVNode("Kommentarer")
    ])), [
      [_directive_translate]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (comment) => {
      return (_openBlock(), _createBlock(TicketViewComment, {
        key: comment.id,
        comment: comment,
        "ticket-id": props.ticket.id
      }, null, 8, ["comment", "ticket-id"]))
    }), 128)),
    _withDirectives((_openBlock(), _createElementBlock("h3", null, [
      _createTextVNode("Återkoppling")
    ])), [
      [_directive_translate]
    ]),
    _createVNode(TicketViewCommentForm, {
      ticket: props.ticket,
      onSaved: commentSaved
    }, null, 8, ["ticket"])
  ]))
}
}

})